import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useScrollLock } from "../../lib/hooks";
import { profile } from "../../data/site";
import { Command, Menu, Moon, SOCIAL_ICONS, Sun, X } from "../../lib/icons";

const LINKS = [
  { to: "/", label: "Home", index: "01" },
  { to: "/resume", label: "Résumé", index: "02" },
  { to: "/projects", label: "Projects", index: "03" },
  { to: "/contact", label: "Contact", index: "04" },
];

const Nav = ({ theme, onToggleTheme }) => {
  const [stuck, setStuck] = useState(false);
  const [drawer, setDrawer] = useState(false);
  const location = useLocation();

  useScrollLock(drawer);

  useEffect(() => {
    setDrawer(false);
  }, [location.pathname]);

  useEffect(() => {
    let ticking = false;
    const update = () => {
      ticking = false;
      setStuck(window.scrollY > 12);
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header className="nav" data-stuck={stuck}>
        <nav className="nav__inner" aria-label="Primary">
          <NavLink to="/" className="brand" aria-label="Ouri Alkada — home">
            <span className="brand__mark" aria-hidden="true">OA</span>
            <span className="brand__text">
              Ouri Alkada
              <small>Software Developer</small>
            </span>
          </NavLink>

          <div className="nav__links">
            {LINKS.map((link) => (
              <NavLink key={link.to} to={link.to} end={link.to === "/"} className="nav__link">
                {link.label}
              </NavLink>
            ))}
          </div>

          <div className="nav__tools">
            <button
              type="button"
              className="kbd-btn"
              onClick={() => window.__openPalette?.()}
              aria-label="Open command palette"
            >
              <Command size={13} />
              <span>K</span>
            </button>

            <button
              type="button"
              className="icon-btn"
              onClick={onToggleTheme}
              aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
            >
              {theme === "dark" ? <Sun size={17} /> : <Moon size={17} />}
            </button>

            <button
              type="button"
              className="icon-btn nav__burger"
              onClick={() => setDrawer((d) => !d)}
              aria-expanded={drawer}
              aria-label={drawer ? "Close menu" : "Open menu"}
            >
              {drawer ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </nav>
      </header>

      {drawer && (
        <div className="drawer" id="mobile-menu">
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className="drawer__link"
              onClick={() => setDrawer(false)}
            >
              {link.label}
              <span>{link.index}</span>
            </NavLink>
          ))}

          <div className="drawer__foot">
            <p className="contact-line__label">Reach me</p>
            <ul className="socials">
              {profile.socials.map((social) => {
                const Icon = SOCIAL_ICONS[social.icon];
                return (
                  <li key={social.label}>
                    <a
                      className="icon-btn"
                      href={social.url}
                      target={social.url.startsWith("http") ? "_blank" : undefined}
                      rel="noopener noreferrer"
                      aria-label={social.label}
                    >
                      <Icon size={18} />
                    </a>
                  </li>
                );
              })}
            </ul>
            <a className="btn btn--ghost btn--sm" href={profile.resume} target="_blank" rel="noopener noreferrer" style={{ marginTop: "1.2rem" }}>
              Download résumé
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Nav;
